import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components.css';

function SimpleCard(props) {
    const image_list = props.list;
    const Extra = props.extra;

    return (
        <div className={`${props.className} simple_card`} style={{ flexWrap: 'wrap' }}> 
            <Extra />
            {image_list.map(img => (
                <div key={img.id}>
                    <Link>
                        <img src={img.img} alt={img.name} />
                    </Link>
                    <p><span>{img.name}</span><br />
                    {img.designation}</p>
                </div>
            ))}
        </div>
    );
}

export default SimpleCard;
